module.exports = __webpack_public_path__ + "img/tatler.07fb4b9a.png";